import { useMutation } from "react-query";
import { employeesService } from "@services/employee-service";

export const useDownloadEmployeeTemplateUploadMutation = () => {
  return useMutation(employeesService.downloadTemplateUpload);
};
